export default function (value) {
  if (value >= 0) {
    return `$${value.toFixed(2)}`;
  } else {
    return `-$${(-1 * value).toFixed(2)}`;
  }
}
